import { Link } from "react-router-dom";
import { ArrowRight, Check, FileText, Upload } from "lucide-react";
import { trackEvent } from "../../lib/api";
import { COMPARE_PATH, COMPARE_PROMISES } from "../../data/compareContent";
import { SectionHeading } from "./CtaButtons";

const CHECKS = ["Profielsysteem en isolatiewaarde", "Glas: HR++ of HR+++", "Demontage, montage en afwerking", "Maten, aantallen en indeling"];

export const CompareBlock = ({ block }) => (
  <section id="offerte-vergelijken" aria-labelledby="compare-block-title" className="section scroll-mt-20 border-t border-slate-200" data-testid="home-compare-block">
    <div className="container-tight grid items-center gap-10 lg:grid-cols-12 lg:gap-16">
      <div className="lg:col-span-6">
        <SectionHeading id="compare-block-title" eyebrow="Offerte vergelijken" title={block.title} lead={block.body} />
        <div className="mt-8 flex flex-col items-start gap-3">
          <Link to={COMPARE_PATH} state={{ from: "/" }} onClick={() => trackEvent("cta_compare_click", { location: "home-compare-block" })}
            data-testid="home-compare-cta" className="btn-primary group min-h-[52px] whitespace-nowrap px-6">
            <Upload className="h-5 w-5" aria-hidden="true" /> Offerte laten vergelijken
            <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" aria-hidden="true" />
          </Link>
          <p className="text-[13.5px] text-slate-500">{COMPARE_PROMISES.join(" • ")}</p>
        </div>
      </div>
      <div className="lg:col-span-6">
        <div className="relative overflow-hidden rounded-3xl bg-ink p-6 sm:p-8" data-testid="home-compare-visual">
          <div className="hero-grid-dark absolute inset-0 opacity-60" aria-hidden="true" />
          <div className="relative">
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-white/10 text-[#7FD3D6]"><FileText className="h-5 w-5" aria-hidden="true" /></span>
              <p className="font-display text-[18px] font-semibold text-white">Dit bekijken wij in uw offerte</p>
            </div>
            <ul className="mt-6 space-y-3">
              {CHECKS.map((c, i) => (
                <li key={c} className="reveal flex items-center gap-3 rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-[15px] text-slate-200" style={{ animationDelay: `${100 + i * 80}ms` }}>
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#7FD3D6]/20 text-[#7FD3D6]"><Check className="h-3.5 w-3.5" aria-hidden="true" /></span>{c}
                </li>
              ))}
            </ul>
            <p className="mt-6 text-[13.5px] leading-relaxed text-slate-400">Uw offerte wordt vertrouwelijk behandeld en niet gedeeld met andere bedrijven.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
);
